import { Spaces } from '@ff-os/rendering-shared/coordinates';
import { Area } from '@ff-os/shared-utils/types/Area';
import { Size } from '@ff-os/shared-utils/types/Size';

export const createFullPreviewSpaces = (
    sceneWidth: number,
    sceneHeight: number,
    designArea: Area,
    viewbox: Size
): Spaces => ({

    sceneWidth,
    sceneHeight,

    designAreaX: designArea.x,
    designAreaY: designArea.y,
    designAreaWidth: designArea.width,
    designAreaHeight: designArea.height,

    designWidth: viewbox.width,
    designHeight: viewbox.height
});